import type { SimpleHeadlineResponse } from '@on3/api';
import { Link } from '@on3/ui-lib/components/Link';
import { useAuth, useSite } from '@on3/ui-lib/index';
import clsx from 'clsx';
import { createTitle } from 'utils/meta';

import { PremiumArticle } from './PremiumArticle';
import styles from './PremiumArticleFeed.module.scss';

interface IPremiumArticleFeedProps {
  list: SimpleHeadlineResponse[];
  isModule?: boolean;
}

export const PremiumArticleFeed = ({
  list,
  isModule = false,
}: IPremiumArticleFeedProps) => {
  const { user } = useAuth();
  const { currentSite } = useSite();

  const siteName =
    currentSite?.organization?.knownAs ?? currentSite?.organization?.name;
  const showSiteName =
    currentSite?.isChannel ||
    (currentSite?.isTeam && currentSite?.organization?.name);

  return (
    <section
      className={clsx(styles.block, {
        [styles.module]: isModule,
      })}
    >
      <header>
        <h2 className={styles.title}>
          {createTitle('Top', showSiteName && siteName, 'Headlines')}
        </h2>
      </header>

      <ul className={styles.articleList} data-premium-article-list>
        {list.map((item) => (
          <li key={item.key}>
            <PremiumArticle {...item} isModule={isModule} />
          </li>
        ))}
      </ul>

      <div className={styles.subscribeWrapper}>
        {user?.has ? (
          <>
            <p className={styles.heading}>Thank you for subscribing.</p>
            <p className={styles.subscribed}>
              You&apos;ve unlocked access to these premium articles.
            </p>
          </>
        ) : (
          <>
            <p className={styles.heading}>
              Read these stories and every premium article
            </p>
            <Link
              className={styles.subscribe}
              href={`${currentSite?.isTeam ? currentSite?.url : ''}/join/`}
            >
              Subscribe
            </Link>
          </>
        )}
      </div>
    </section>
  );
};
